/*
 * NovaFronten Partner Contact Form
 * External JS — loaded as theme asset
 */
(function() {
  'use strict';

  var container = document.getElementById('nf-contact-form-container');
  if (!container) return;

  var form = document.getElementById('nf-contact-form');
  if (!form) return;

  var API_ENDPOINT = container.getAttribute('data-api-endpoint') || '';

  function validate() {
    var valid = true;
    var errs = form.querySelectorAll('.nf-cf-err');
    for (var i = 0; i < errs.length; i++) errs[i].classList.remove('nf-cf-err');

    var name = form.querySelector('#nfc-name');
    if (!name.value.trim()) { name.closest('.nf-cf-field').classList.add('nf-cf-err'); valid = false; }

    var email = form.querySelector('#nfc-email');
    if (!email.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
      email.closest('.nf-cf-field').classList.add('nf-cf-err'); valid = false;
    }

    var msg = form.querySelector('#nfc-message');
    if (!msg.value.trim()) { msg.closest('.nf-cf-field').classList.add('nf-cf-err'); valid = false; }

    return valid;
  }

  var isSubmitting = false;

  function doSubmit() {
    if (isSubmitting) return;

    var msgSuccess = document.getElementById('nfc-msg-success');
    var msgError = document.getElementById('nfc-msg-error');
    msgSuccess.classList.remove('nf-cf-visible');
    msgError.classList.remove('nf-cf-visible');

    if (!validate()) {
      var first = form.querySelector('.nf-cf-err');
      if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (!API_ENDPOINT) {
      document.getElementById('nfc-msg-error-text').textContent = 'Kein API-Endpunkt konfiguriert.';
      msgError.classList.add('nf-cf-visible');
      return;
    }

    isSubmitting = true;
    var btn = document.getElementById('nfc-submit-btn');
    btn.classList.add('nf-cf-loading');

    var fd = new FormData();
    fd.append('action', 'contact');
    fd.append('name', form.querySelector('#nfc-name').value.trim());
    fd.append('email', form.querySelector('#nfc-email').value.trim());
    fd.append('phone', (form.querySelector('#nfc-phone') || {}).value || '');
    fd.append('company', (form.querySelector('#nfc-company') || {}).value || '');
    fd.append('message', form.querySelector('#nfc-message').value.trim());

    fetch(API_ENDPOINT, { method: 'POST', body: fd })
      .then(function(res) { return res.json().then(function(data) { return { ok: res.ok, data: data }; }); })
      .then(function(result) {
        btn.classList.remove('nf-cf-loading');
        if (result.ok && result.data.success) {
          form.reset();
          form.style.display = 'none';
          msgSuccess.classList.add('nf-cf-visible');
          window.scrollTo({ top: container.offsetTop - 100, behavior: 'smooth' });
        } else {
          isSubmitting = false;
          document.getElementById('nfc-msg-error-text').textContent = result.data.error || 'Ein Fehler ist aufgetreten.';
          msgError.classList.add('nf-cf-visible');
        }
      })
      .catch(function() {
        isSubmitting = false;
        btn.classList.remove('nf-cf-loading');
        document.getElementById('nfc-msg-error-text').textContent = 'Netzwerkfehler. Bitte versuchen Sie es erneut.';
        msgError.classList.add('nf-cf-visible');
      });
  }

  var submitDiv = document.getElementById('nfc-submit-btn');
  if (submitDiv) {
    submitDiv.style.pointerEvents = 'auto';
    submitDiv.style.position = 'relative';
    submitDiv.style.zIndex = '99999';
    submitDiv.style.userSelect = 'none';

    submitDiv.onclick = function(e) {
      if (e && e.preventDefault) e.preventDefault();
      doSubmit();
    };

    var pointerFired = false;
    submitDiv.addEventListener('pointerdown', function() { pointerFired = true; setTimeout(function() { pointerFired = false; }, 500); });
    submitDiv.addEventListener('pointerup', function() { if (pointerFired) { pointerFired = false; doSubmit(); } });

    submitDiv.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); doSubmit(); }
    });
  }
})();
